import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  mb8: {
    marginBottom: "1rem",
  },
});
